import * as $ from "jquery";
import * as _ from "lodash";
import { ReportFilesCollection } from "../../collections/ReportFiles";
import { ReportsCollection } from "../../collections/Reports";
import { TimezoneCollection } from "../../collections/Timezones";
import { Utils } from "../../common/utils";
import { BaseInternalView } from "../_BaseViews";
import { GenericDeleteModal } from "../modals/GenericDeleteModal";
import { ModifyReportModal } from "../modals/reports/ModifyReportModal";
import { ReportFilesModalView } from "../modals/reports/ReportFilesModal";
import { ReportsViewOptions } from "./ReportsView";
import { downloadReport, getProgressPropertiesFromStatus, pollReportTask } from "./ReportUtils";

declare var CONFIG;

interface RootReportViewOptions extends ReportsViewOptions {
    reportsCollection: ReportsCollection;
    reportFilesCollection: ReportFilesCollection;
    report: Backbone.Model;
    orgId: number;
}

export class RootReportView extends BaseInternalView {
    public options: RootReportViewOptions;
    private template = _.template(require("../../templates/reports/rootReport.html"));
    private modals: ReportFilesModalView[] = [];

    constructor(options: RootReportViewOptions) {
        super(
            _.extend(options, {
                events: {
                    "click .report-delete": "handleDeleteReport",
                    "click .report-clone": "showCloneReportModal",
                    "click .report-file-download": "handleReportFileDownload",
                    "click .view-old-reports": "showReportFilesModal",
                    "click .run-button a": "handleRunReport",
                },
            })
        );
    }

    render() {
        var timezones = new TimezoneCollection();
        var tz = timezones.findWhere({ momentjs: this.options.report.get("timezone") });

        var report = this.options.report;
        this.$el.html(
            this.template({
                permissionCollection: this.options.permissionCollection,
                reportFilesCollection: this.options.reportFilesCollection.where({
                    report_id: this.options.report.get("id"),
                }),
                orgId: this.options.orgId,
                report: this.options.report,
                reporterUrl: CONFIG.reporter.url + "/downloadreportfile",
                intervalString: Utils.Time.getIntervalString(
                    report.get("interval"),
                    report.get("offset_seconds"),
                    report.get("offset_days"),
                    report.get("offset_months"),
                    tz.get("utcOffset")
                ),
            })
        );
        return this;
    }

    private handleDeleteReport(e: JQuery.UIEventBase) {
        e.preventDefault();
        var reportId = this.options.report.get("id");
        var reportToDelete: Backbone.Model = this.options.reportsCollection.findWhere({ id: reportId });

        var modal = new GenericDeleteModal({
            type: "Report",
            name: reportToDelete.get("name"),
            func: () => {
                reportToDelete.destroy();
                this.$(e.currentTarget).parents(".root-report").remove();
            },
        });

        $(".modals").append(modal.render().el);
        modal.show();
    }

    private showCloneReportModal() {
        const reportId = this.options.report.get("id");

        const view = new ModifyReportModal(
            _.extend(
                {
                    isClone: true,
                    parentView: this,
                    modelId: null,
                    reportId: reportId,
                    reportsCollection: this.options.reportsCollection,
                    orgId: this.options.orgId,
                },
                this.options
            )
        );
        $(".modals").append(view.render().el);
        view.show();
    }

    private handleReportFileDownload(e: JQuery.UIEventBase) {
        const reportKey = <string>$(e.currentTarget).attr("id");
        const reportName = <string>$(e.currentTarget).parents(".root-report").find("h3").text();
        downloadReport(reportKey, reportName, this.options.reportFilesCollection.downloadReport());
    }

    private showReportFilesModal() {
        var view = new ReportFilesModalView(
            _.extend(
                {
                    modelId: null,
                    parentView: this,
                    reportFilesCollection: this.options.reportFilesCollection,
                },
                this.options
            )
        );
        $(".modals").append(view.render().el);
        view.show();
        this.modals.push(view);
    }

    private showProgress(showProgress: boolean, status?: string, error?: string) {
        this.$(".download-progress").toggleClass("hidden", !showProgress);
        this.$(".run-button").toggleClass("hidden", showProgress);

        if (showProgress) {
            const { width, step, success } = getProgressPropertiesFromStatus(status, error);
            this.$(".download-progress .progress-bar").toggleClass("progress-bar-success", success);
            this.$(".download-progress .progress-bar").toggleClass("progress-bar-danger", !success);
            this.$(".download-progress .progress-bar").css({ width: width + "%" });
            this.$(".download-progress .progress-bar").text(step);
        }
    }

    private handleRunReport() {
        this.showProgress(true);
        $.ajax({
            type: "POST",
            url: CONFIG.reporter.url + "/report/" + this.options.report.get("id"),
            dataType: "json",
            contentType: "application/json; charset=utf-8",
            complete: (res) => {
                this.pollReportTask(res.responseJSON.taskId);
            },
        });
    }

    private pollReportTask(taskId: number) {
        pollReportTask({
            taskId,
            report: this.options.report,
            updateStatusFn: (status, error) => {
                this.showProgress(true, status, error);
            },
            doneFn: () => {
                $.when(this.options.reportFilesCollection.getCollectionFetchPromise()).done(() => {
                    this.render();
                });
            },
        });
    }

    remove() {
        _.each(this.modals, (m) => {
            m.remove();
        });
        return super.remove();
    }
}



// WEBPACK FOOTER //
// ./srv/public/js/views/reports/RootReportView.ts